import { render, staticRenderFns } from "./FacetsFilters.vue?vue&type=template&id=4694d3a5&"
import script from "./FacetsFilters.vue?vue&type=script&lang=ts&"
export * from "./FacetsFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports